import UI from "./base/UI";
import {setActivePosition} from "../functions/simple.ui";
import { isA11yCheckVersion } from "../functions/a11y.ui";

/**
 * SubTab
 */

 /**
#### HTML 구조 및 Data 속성 사용법
** [http://172.20.160.28:9700/kbank_html_mmk/components/component_tab.html](http://172.20.160.28:9700/kbank_html_mmk/components/component_tab.html)
*/
class SubTab extends UI {
    defaults = {
        no: 0
    };

    constructor(el, options) {
        super('subTab', el);

        this.init(el, options);
    }

    init(el, options) {
        if (options) {
            this.defaults = {...this.defaults, ...this.parseOptions(options)};
        }

        this.render();
    }

    update() {
        this.checkShowButton();
        this.setPosition();
    }

    render() {
        this.detachEvents();

        const $uiTabNav = this.$el.find('.ui-subTab-nav > ul');

        $uiTabNav.attr({role: 'tablist'});
        $uiTabNav.find('li').attr({role: 'none'});
        $uiTabNav.find('li a').attr({role: 'tab'});

        this.attachCommonEvents();
        this.setPosition();
        this.$window.trigger(`resize${this.eventId}`);
        if (this.$el.find('.ui-subTab-nav li').length !== this.$el.find('.ui-subTab-content').length && this.$el.attr('data-subTab-content') == undefined) {
             //240307 : this.$el.attr('data-subTab-content') == undefined   추가  
            let activeIndex = this.$el.find('.ui-subTab-nav li.active').index();
            activeIndex = activeIndex === -1 ? 0 : activeIndex;
            this.a11y(activeIndex);
            console.log(this.$el);
            return;
        }
        this.attachStaticEvents();
        this.open(this.defaults.no);
    }

    setPosition() {
        if (this.$el.find('.ui-subTab-nav li.active').length <= 0) {
            this.$el.find('.ui-subTab-nav li').eq(this.defaults.no).addClass('active');
        }
        if (this.$el.find('.ui-subTab-nav').length > 0 ) {
            setActivePosition(this.$el.find('.ui-subTab-nav'), this.$el.find('.ui-subTab-nav li.active'));
        }
        // setActivePosition(this.$el.find('.ui-subTab-nav'), this.$el.find('.ui-subTab-nav li.active'));
    }

    attachStaticEvents() {
        this.$el.on(`click${this.eventId}`, '.ui-subTab-nav a', (e) => {
            e.preventDefault();
            const $this = $(e.currentTarget);
            const index = $this.closest('li').index();
            
            this.open(index);
            if (this.tabCallback && $.isFunction(this.tabCallback)) { // 240923 CHPFMTASK-870 tab callback 추가
                this.tabCallback(index);
            }
        });
    }

    attachCommonEvents() {
        this.$el.on(`click${this.eventId}`, '.ui-subTab-btn-expand', (e) => {
            e.preventDefault();
            const $this = $(e.currentTarget);

            this.$el.toggleClass('open');
            if (this.$el.hasClass('open')) {
                $this.find('.hide-txt').text('접기');

            } else {
                $this.find('.hide-txt').text('펼치기');
                this.setPosition();
            }
        });

        this.$window.on(`resize${this.eventId}`, (e) => {
            this.checkShowButton();
        });

        if(isA11yCheckVersion()){
            this.isA11yTabEvents();
        }
    }

    checkShowButton() {
        if (!this.$el.hasClass('open')) {
            if (this.$el.find('.ui-subTab-nav').outerWidth() < this.$el.find('.tab-nav').width() + 50) {
                this.$el.find('.ui-subTab-btn-expand').css('display', 'inline-flex');
            } else {
                this.$el.find('.ui-subTab-btn-expand').css('display', 'none');
            }
        }
    }
    /**
     * subTab open event
     * @param {Number} index
     * @example 
     * $('.ui-subTab').data('ui').open();
     */
    open(index) {
        if (this.$el.attr('data-subTab-content') == undefined) { //240307 : 분기 추가 
            this.$el.find('.ui-subTab-nav li')
            .eq(index).addClass('active')
            .siblings().removeClass('active');
            this.$el.find('.ui-subTab-content')[0] && this.$el.find('.ui-subTab-content')
                .eq(index).show()
                .siblings().hide();
        } else {
            this.$el.find('.ui-subTab-nav li').eq(index).addClass('active').siblings().removeClass('active');;
            $(`[subTab-content-id="${this.$el.attr('data-subTab-content')}"]`).find('.ui-subTab-content').eq(index).show().siblings().hide()
        }
        this.setPosition();
        this.a11y(index);

        if(isA11yCheckVersion()){
            $('.tab-item a').attr('aria-selected','false');
            $('.tab-item.active a').attr('aria-selected','true');
            $('.tab-item.on a').attr('aria-selected','true');
        }
    }

    a11y(index) {
        this.$el.find('.ui-subTab-nav li a')
            .attr({'aria-selected': false})
            .eq(index)
            .attr({'aria-selected': true});
        // .find('.hide-txt').remove().end()
        // .eq(index).find('a').prepend(`<span class="hide-txt">선택됨</span>`);
    }

    detachEvents() {
        this.$el.off(this.eventId);
        this.$window.off(this.eventId);
    }

    destroy() {
        this.detachEvents();
    }

    /**
     * subTab 콜백
     * @param {function} callback
     * @example 
     * $('.ui-subTab').data('ui').callback(function(){});
     */
    callback(callback) { // 240923 CHPFMTASK-870 tab callback 추가
        this.tabCallback = callback;
    }
    isA11yTabEvents(){
        const tabItems = [...this.$el[0]?.querySelectorAll('.tab-item'), ...this.$el[0]?.querySelectorAll('.toggle-item')].filter((item) => !!item && item);

        tabItems && tabItems?.length && Array.from(tabItems)?.forEach((list,idx) => {
            const linkEle = list?.querySelector('a');

            //const isCheckActive = !!list?.classList.contains('active');

            //linkEle && linkEle?.setAttribute('href','javascript:void();');

            list?.setAttribute('role','presentation none');

            $(list).find('.tab-item a')?.attr('aria-selected','false');
            $(list).find('.tab-item.active > a')?.attr('aria-selected','true');
            $(list).find('.tab-item.on > a')?.attr('aria-selected','true');

            //linkEle && linkEle?.setAttribute('aria-selected', isCheckActive); //active일때

            $(list).off(`click${this.eventId}`).on(`click${this.eventId}`, (e) => {
                e.preventDefault();

                $(document).find('.tab-item a')?.attr('aria-selected','false');
                $(document).find('.tab-item.active > a')?.attr('aria-selected','true');
                $(document).find('.tab-item.on > a')?.attr('aria-selected','true');

                //$('.ui-subTab')?.data('ui') && $('.ui-subTab')?.data('ui')?.init();

                //Popup?.a11yDetctClosePopup();
            });
        });
    }
}

export default SubTab;
